import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled from "styled-components";

import { Route } from "react-router-dom";
import { Switch } from "react-router";

import config from "../../core/config";
import Login from "./containers/login";
import Buy from "./containers/buy";
import Recover from "./containers/recover";
import RecoverMessageSuccess from "./containers/recoverMessageSuccess";
import Reset from "./containers/reset";

import { doPostLog } from "../app/state/actions";

export const LOGIN_PATH = "/management/login";
export const RECOVER_PATH = "/recupera/:content";
export const RECOVER_MESSAGE_PATH = "/recupera-sucesso";
export const NEW_PASSWORD_PATH = "/nova-senha";
export const BUY_PATH = "/assine";

const AccountWrapper = styled.div`
  background: #eeeeee;
  min-height: 100vh;
`;

class Router extends Component {
  componentDidCatch(error, info) {
    if (config.env === "production") {
      this.props.doPostLog({
        buildNumber: config.buildNumber,
        error,
        info,
        location: this.props.history.location.pathname
      });
    }
  }

  render() {
    return (
      <AccountWrapper>
        <Switch>
          <Route path={LOGIN_PATH} component={Login} />
          <Route path={RECOVER_PATH} component={Recover} />
          <Route path={RECOVER_MESSAGE_PATH} component={RecoverMessageSuccess} />
          <Route path={NEW_PASSWORD_PATH} component={Reset} />
          <Route path={BUY_PATH} component={Buy} />
          <Route path={"/"} component={Login} />
        </Switch>
      </AccountWrapper>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      doPostLog
    },
    dispatch
  );
};

const Routered = withRouter(connect(mapStateToProps, mapDispatchToProps)(Router));

Routered.displayName = "AccountRouter";

export default Routered;
